import { style } from '@vanilla-extract/css';

export const searchContainer = style({
  display: 'flex',
  width: '280px',
});
